var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Field } from 'formik';
import React from 'react';
/**
 * Maps over the current channel's countries and displays them.
 */
export function CountriesInput(_a) {
    var { id, name, onChange, onFocus, countries } = _a, rest = __rest(_a, ["id", "name", "onChange", "onFocus", "countries"]);
    return (React.createElement(Field, Object.assign({ name: name, onFocus: onFocus }, rest, { render: ({ field }) => {
            return (React.createElement("select", Object.assign({ id: id || name }, rest, field, { onChange: (e) => {
                    field.onChange(e);
                    onChange && onChange(e);
                } }),
                countries.map((country) => (React.createElement("option", { key: country.code, value: country.code }, country.name))),
                ";"));
        } })));
}
//# sourceMappingURL=CountriesInput.js.map